// extracted by mini-css-extract-plugin
module.exports = {"logo":"hotel_logo_logo__3Y9wo","logoContainer":"hotel_logo_logoContainer__1_N68"};